var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modatta-new-offer-preview"},[_c('modatta-new-offer-preview',{attrs:{"offer":_vm.options.offer,"brand-id":_vm.options.brandId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }